export default class Constants {
    static DEVICE_TYPE = {
        PHONE: "device-phone",
        TABLET_PORTRAIT: "device-tablet-portrait",
        TABLET_LANDSCAPE: "device-tablet-landscape",
        DESKTOP_OR_LAPTOP: "device-desktop-or-laptop"
    };

    static MEDIA_QUERY = {
        MAX_PHONE_WIDTH: 480,
        MAX_TABLET_PORTRAIT_WIDTH: 768,
        MAX_TABLET_LANDSCAPE_WIDTH: 1024
    };

    static COLORS = {
        MAIN: "#0094FE"
    }
}
